module.exports = __webpack_public_path__ + "img/seasonly_white.cedaed60.png";